import React, { useState, useEffect } from 'react'
import { Button, Col, Form, Input, Modal, Row, DatePicker } from 'antd'
import ImageList from '../../containers/Complaint/Photos'
import DocumentList from "../../components/DocumentList";
import moment from 'moment'
import axios from '../../util/Api';

function QuickCloseModal({
    visible,
    onCancel,
    loading,
    form,
    match,
    history,
    filters,
    fetchJobCardData,
    jobCardData,
    ...props
}) {
    const [documents, setDocuments] = useState([])
    const [photos, setPhotos] = useState([])
    const [message, setMessage] = useState(null)
    const [closeCountdown, setCloseCountdown] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const { getFieldDecorator } = form

    const getPhotoDedupKey = (photo) => {
        if (!photo) return ''
        if (photo.url) return `url:${photo.url}`
        const name = photo.name || ''
        const size = typeof photo.size === 'number' ? photo.size : ''
        const type = photo.type || photo.mimeType || ''
        return `file:${name}|${size}|${type}`
    }

    const dedupePhotos = (photoList = []) => {
        const seen = new Set()
        return (photoList || []).filter((photo) => {
            const key = getPhotoDedupKey(photo)
            if (!key || seen.has(key)) {
                return false
            }
            seen.add(key)
            return true
        })
    }

    const triggerCloseCountdown = () => {
        setCloseCountdown(5)
        const timer = setInterval(() => {
            setCloseCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer)
                    fetchJobCardData()
                    onCancel()
                    return null
                }
                return prev - 1
            })
        }, 1000)
    }

    const getDocumentData = (data) => {
        setDocuments(data)
    }

    const getImageData = (data) => {
        const uniquePhotos = dedupePhotos(Array.isArray(data) ? data : [])
        setPhotos(uniquePhotos)
        form.setFieldsValue({ photos: uniquePhotos })
    }

    // useEffect(() => {
    //     console.log(jobCardData)
    // }, [jobCardData])

    const handleSubmit = (e) => {
        e.preventDefault()
        form.validateFields((err, values) => {
            if (!err) {
                setIsLoading(true)
                const quickCloseData = {
                    closingDate: values.closingDate,
                    remarks: values.closingRemarks,
                    amount: values.closingAmount || 0,
                    jobCard: jobCardData._id,
                    complaint: jobCardData.complaint && jobCardData.complaint._id,
                    documents,
                    photos: dedupePhotos(photos)
                }
                // console.log('quickCloseData', quickCloseData);

                // create formData
                const formData = new FormData()
                const documentData = [];
                formData.append('closingDate', quickCloseData.closingDate)
                formData.append('remarks', quickCloseData.remarks)
                formData.append('amount', quickCloseData.amount)
                formData.append('jobCard', quickCloseData.jobCard)
                formData.append('complaint', quickCloseData.complaint)

                quickCloseData.documents && quickCloseData.documents.map((item, index) => {
                    formData.append('files', item.file);
                    let data = { ...item, fieldType: 'closing' };
                    delete data.file;
                    documentData.push(data)
                });
                formData.append('documentData', JSON.stringify(documentData));

                quickCloseData.photos && quickCloseData.photos.map((item, index) => {
                    // console.log('item', item);
                    formData.append('files', item);
                });

                axios.post('/quick-close-job-card', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                    .then(res => {
                        // console.log('res', res);
                        setMessage({
                            message: 'Job Card closed successfully with voucher number ' + res.data.voucherNo,
                            type: 'success'
                        })
                        // fetchJobCardData()
                        triggerCloseCountdown()
                    })
                    .catch(err => {
                        console.log('err', err);
                        setMessage({
                            message: err.response.data.message,
                            type: 'error'
                        })
                    }).finally(() => {
                        setIsLoading(false)
                    })
            }
        })
    }

    return (
        <Modal
            title="Quick Close Job Card"
            visible={visible}
            onCancel={onCancel}
            footer={
                <div>
                    {message && <div style={{ color: message.type === 'success' ? '#038fde' : 'tomato', marginBottom: 16 }}>{message.message}</div>}
                    {closeCountdown && <div>Closing in {closeCountdown} seconds...</div> || null}
                </div>
            }
        >
            <Form onSubmit={handleSubmit}>

                <Form.Item label="Closing Date">
                    {getFieldDecorator('closingDate', {
                        rules: [{ required: true, message: 'Closing Date is required!' }],
                        initialValue: moment()
                    })(
                        <DatePicker format="DD-MM-YYYY" disabledDate={(current) => {
                            const complaintDate = jobCardData.complaint && jobCardData.complaint.complaintDate
                            return current && current <= moment(complaintDate).startOf('day')
                        }} />
                    )}
                </Form.Item>
                <Form.Item label="Remarks">
                    {getFieldDecorator('closingRemarks', {
                        rules: [{ required: true, message: 'Remarks are required!' }]
                    })(
                        <Input.TextArea rows={4} />
                    )}
                </Form.Item>

                <Form.Item label="Amount">
                    {getFieldDecorator('closingAmount', {
                        rules: [{ required: true, message: 'Amount is required!' }],
                        initialValue: 0
                    })(
                        <Input type="number" />
                    )}
                </Form.Item>

                <DocumentList
                    match={match}
                    history={history}
                    item={filters['documents']}
                    form={form}
                    // subDocumentFilters={subDocumentFilters}
                    getDocumentData={getDocumentData}
                />

                <Row type="flex" gutter={[8, 8]}>
                    <Col span={24}>
                        <Form.Item label="Closing Photos">
                            {getFieldDecorator('photos', {})(
                                <ImageList
                                    match={match}
                                    history={history}
                                    documentData={photos}
                                    item={filters['photos']}
                                    form={form}
                                    getDocumentData={getImageData}
                                />
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading} disabled={closeCountdown > 0}>
                        Quick Close
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    )
}

// Since we're using antd v3, we still need to use the Form.create() HOC
export default Form.create()(QuickCloseModal)
